export enum OrganizationTypeEnum {
    univeristy = 4
}
